<template>
    <div class="home">
        <Topbar />
        <div class="container-fluid text-left" style="margin-top: 72px; justify-content: center; display: flex">
            <!-- Content Row -->
            <div class="card shadow mb-4 col-md-6 p-0">
                <div class="card-header py-2" :style="{ backgroundColor: moduloAtual().color }">
                    <h6 class="m-0 font-weight-bold text-white">
                        <span v-if="dados.cliente != null">Cancelamento: {{ id }} - {{ dados.cliente }}</span>
                        <span v-else>Carregando... </span>
                        <div v-show="carregando" class="spinner-grow">
                            <span class="sr-only">Loading...</span>
                        </div>
                    </h6>
                </div>
                <fieldset v-if="dados.cliente != null" :disabled="carregando">
                    <div class="card-body bg-light text-primary-dark">
                        <div>
                            <div class="text-center col-auto p-0">
                                <label for="" v-if="proximoEndereco"><b>Vá ao endereço <span class="text-danger">{{ proximoEndereco }}</span></b></label>
                                <label for="" v-else><b>Não há sugestão de endereço, informe o endereço que deseja armazenar</b></label>
                                <br>
                                <div class="col p-0">
                                    <div class="col p-0 text-left">
                                        <label for="pesquisa">Endereço: </label>
                                    </div>
                                    <div class="col p-0">
                                        <InputDefaultApp
                                            inputPlaceHolderSufixo="Digite o endereço aqui"
                                            titleScan="Escanear endereço"
                                            typeInputMode="text"
                                            @displayScanFunction="onDecode"
                                            :enterKey="handleInput"
                                            idInput="endereco"
                                            autofocus
                                            v-model="endereco"
                                            :errorMessage="(errors.endereco ? errors.endereco[0] : '') || message"
                                        >
                                        </InputDefaultApp>
                                    </div>
                                </div>
                            </div>

                            <div class="row px-2">
                                <div class="col-lg-12 table-responsive">
                                    <table class="table-sm">
                                        <thead>
                                            <tr style="white-space: nowrap">
                                                <th>Próximos Endereços</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr
                                                v-for="line in proximosEnderecos"
                                                :key="line"
                                                :style="{
                                                    backgroundColor: '#' + line.statusbackground,
                                                    color: '#' + line.statuscolor,
                                                }"
                                            >
                                                <td>
                                                    <div>
                                                        <div style="display: flex; justify-content: space-between">
                                                            <span class="text-left">{{ line }}</span>
                                                        </div>
                                                    </div>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </fieldset>
            </div>
        </div>
        <ForbiddenModal />
        <LogoutModal />
        <Modal
            id="warningModal"
            title="Aviso"
            :confirmFunction="okWarningModal"
            :carregando="carregando"
            confirmText="Ok"
        >
            {{ message }}
        </Modal>
        <Modal
            id="scanModal"
            title="Escanear"
            :carregando="carregando"
            :buttonList="[]"
            :cancelFunction="fecharScan"
        >
            <StreamBarcodeReader v-if="scanAberto" @decode="onDecode" @loaded="onLoaded" @error="onError"></StreamBarcodeReader>
        </Modal>
    </div>
</template>

<script>
// @ is an alias to /src
import Topbar from "@/components/Topbar.vue";
import LogoutModal from "@/components/LogoutModal.vue";
import ViewMixin from "./ViewMixin";
import api, { setEnderecoAtual, setEnderecoOriginal } from "../services/api";
import $ from "jquery";
import {
    ClientErrorException,
    DEFAULT_ERROR_MESSAGE,
    EnderecoDiferenteException,
    ListaConcluidaException,
    PermissaoException,
    ServerErrorException,
    TokenInvalidoException,
    ValidationException,
} from "../services/exceptions";
import { enterKey, dateFormat, selecionar } from "../utils";
import ForbiddenModal from "../components/ForbiddenModal.vue";
import InputDefaultApp from "../components/InputDefaultApp.vue";
import Modal from "../components/Modal.vue";
import { StreamBarcodeReader } from "vue-barcode-reader";
import Audio from "../services/audioService";

export default {
    name: "EnderecosCancelamento",
    mixins: [ViewMixin],
    components: {
        Topbar,
        LogoutModal,
        ForbiddenModal,
        Modal,
        StreamBarcodeReader,
        InputDefaultApp
    },
    props: ["id"],
    data: () => {
        return {
            idname: "idlista",
            baseUrl: "cancelamento/enderecos",
            title: {
                icon: "fas fa-cash-register",
                text: "Cancelamento",
            },
            sort: "nome",
            sortDirection: "asc",
            filtro: {
                pesquisa: "",
            },
            arquivoLabel: "Selecionar Arquivo",
            arquivoNome: "",
            arquivos: null,
            proximoEndereco: null,
            proximosEnderecos: [],
            endereco: "",
            scanAberto: false,
        };
    },
    mounted() {
        // this.getCombos();
        this.list();
    },
    methods: {
        enterKey,
        dateFormat,

        async list() {
            this.carregando = true;

            try {
                // $("#filtrocard").collapse("hide");

                let { baseUrl, sort, sortDirection, filtro, perPage, pular, id } = this;
                let response = await api.get(`/${baseUrl}/${id}`, {
                    params: {
                        sort: `${sort} ${sortDirection}`,
                        ...filtro,
                        perPage,
                        pular,
                    },
                });

                response.data.enderecos.forEach((e, i) => {
                    if (i === 0) {
                        this.proximoEndereco = e
                    } else {
                        this.proximosEnderecos.push(e)
                    }
                }, this);
                this.dados = response.data;

                setTimeout(() => {
                    selecionar('#endereco')
                }, 100);
                // this.totalRows = response.data.totalRows;
            } catch (e) {
                this.exception = e;
                if (e instanceof ValidationException) {
                    this.handleValidationException(e);
                } else if (e instanceof TokenInvalidoException) {
                    this.handleTokenInvalidoException();
                } else if (e instanceof PermissaoException) {
                    this.handlePermissaoException();
                } else if (e instanceof ListaConcluidaException) {
                    this.message = e.message;
                    $("#warningModal").modal("show");
                    setTimeout(() => {
                        this.carregando = false;
                    }, 100);
                } else if (e instanceof EnderecoDiferenteException) {
                    this.$router.push('/cancelamento/enderecos/' + this.id)
                } else if (e instanceof ClientErrorException) {
                    this.message = e.message;
                    $("#warningModal").modal("show");
                } else if (e instanceof ServerErrorException) {
                    alert(e.message);
                } else {
                    alert(DEFAULT_ERROR_MESSAGE);
                }
                console.error(e);
            }

            this.carregando = false;
        },

        async verificarEndereco() {
            let sucesso = null;
            this.carregando = true;

            try {
                let endereco = $("#endereco").val();

                let { baseUrl } = this;
                await api.get(`/${baseUrl}/verificar`, {
                    params: {
                        endereco
                    },
                });

                sucesso = true;
                // Audio.success();
            } catch (e) {
                this.exception = e;
                if (e instanceof ValidationException) {
                    Audio.ops();
                    this.handleValidationException(e);
                } else if (e instanceof TokenInvalidoException) {
                    this.handleTokenInvalidoException();
                } else if (e instanceof PermissaoException) {
                    this.handlePermissaoException();
                } else if (e instanceof ListaConcluidaException) {
                    this.message = e.message;
                    $("#warningModal").modal("show");
                } else if (e instanceof EnderecoDiferenteException) {
                    this.$router.push('/cancelamento/enderecos/' + this.id)
                } else if (e instanceof ClientErrorException) {
                    this.message = e.message;
                    $("#warningModal").modal("show");
                } else if (e instanceof ServerErrorException) {
                    alert(e.message);
                } else {
                    alert(DEFAULT_ERROR_MESSAGE);
                }
                sucesso = false;
                setTimeout(() => {
                    selecionar('#endereco')
                }, 100);
            }

            this.carregando = false;
            return sucesso;
        },

        okWarningModal() {
            let { exception } = this;
            $("#warningModal").modal("hide");
            if (exception instanceof ListaConcluidaException || exception instanceof ClientErrorException) {
                this.$router.push('/cancelamento')
            }
        },

        async handleInput(e) {
            console.log(e)
            if (await this.verificarEndereco()) {
                let endereco = $("#endereco").val();
                this.endereco = endereco;
                setEnderecoAtual(endereco)
                setEnderecoOriginal(this.proximoEndereco ?? endereco)
                this.$router.push('/cancelamento/proximo-item/' + this.id)
            }
        },

        abrirScan() {
            this.scanAberto = true;
            $("#scanModal").modal("show");
        },
        fecharScan() {
            this.scanAberto = false;
            $("#scanModal").modal("hide");
        },
        onDecode(r) {
            this.endereco = r;
            this.fecharScan();
            setTimeout(() => {
                this.handleInput(null);
            }, 100);
        },
        onError(r) {
            console.log(r)
            alert("Não foi possível escanear")
        },
        onLoaded() {
            console.log("Scaneando código de barras ou QR Code!");
        },
    },
};
</script>

<style scoped lang="scss">
.spinner-grow {
    width: 1em;
    height: 1em;
}

@media only screen and (min-width: 768px) {
}
</style>
